// extracted by mini-css-extract-plugin
export default {"skillTransition":"AboutMe_skillTransition__a8OOI","openclose":"AboutMe_openclose__2QHk5"};